<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
      </div>
      <div class="nav-middle">选择标签</div>
      <div >
        <div class="nav-lable ub ub-pc ub-ac" @click="save()">完成</div>
        <img src="../../assets/img/更换.png" class="nav-img none" />
      </div>
    </div>

    <div class="edit-tags">
      <span>编辑我的已选标签</span>
      <div class="selected ub">
        <li class="selected-on" v-for="(item, index) in inst" :key="index">
          <div class="item ub ub-pc ub-ac1" @click="chosetag(index)">
            <span>{{ item }}</span>
            <span class="del">X</span>
          </div>
        </li>
      </div>
    </div>

    <div class="recommended-tags">
      <span>推荐标签</span>
      <div class="unselected">
        <li :class="{'label':true, 'unselected-on': item.on == 1 }" v-for="(item, index) in arr" :key="index" @click="choseItem(item.name)">
          <span class="on-label">{{ item.name }}</span>
        </li>
      </div>
    </div>

    <alert ref="myConfirm"></alert>
  </div>
</template>
  
  <script>
import * as tool from "../../api/common";
import Alert from "../../components/Alert.vue";
import { mapMutations, mapActions } from "vuex";
export default {
  components: {
    alert: Alert,
  },
  data() {
    return {
      arr: [],
      inst: [],
      arr_boy: [
          { "name": "御姐", "on": 0 },
          { "name": "萝莉", "on": 0 },
          { "name": "大长腿", "on": 0 },
          { "name": "各种控", "on": 0 },
          { "name": "不污", "on": 0 },
          { "name": "二次元", "on": 0 },
          { "name": "呆萌", "on": 0 },
          { "name": "小火车", "on": 0 },
          { "name": "正太", "on": 0 },
          { "name": "暖男", "on": 0 },
          { "name": "硬汉", "on": 0 },
          { "name": "大叔", "on": 0 },
          { "name": "腹黑", "on": 0 },
          { "name": "男神", "on": 0 },
          { "name": "游戏", "on": 0 },

          { "name": "游戏宅", "on": 0 },
          { "name": "成熟稳重", "on": 0 },
          { "name": "运动达人", "on": 0 },
          { "name": "硬汉", "on": 0 },
          { "name": "黏人精", "on": 0 },
          { "name": "小鲜肉", "on": 0 },
          { "name": "旅行", "on": 0 },
          { "name": "美食探索者", "on": 0 },
          { "name": "行走的图书馆", "on": 0 },
          { "name": "唠嗑型选手", "on": 0 },
          { "name": "完美主义", "on": 0 },
          { "name": "会弹唱", "on": 0 },
          { "name": "摄影爱好者", "on": 0 },
          { "name": "电影迷", "on": 0 },
          { "name": "科技控", "on": 0 },
          { "name": "灵魂伴侣", "on": 0 },
          { "name": "有点恋爱脑", "on": 0 },
          { "name": "爹系男友", "on": 0 },
          { "name": "手机重度爱好者", "on": 0 },
          { "name": "腹肌拥有者", "on": 0 },
          { "name": "青春男大", "on": 0 },
          { "name": "少年感", "on": 0 },
          { "name": "冷静理性", "on": 0 },
          { "name": "情绪波动小", "on": 0 },
          { "name": "有上进心", "on": 0 },
          { "name": "生活圈子简单", "on": 0 },
          { "name": "日常活动丰富", "on": 0 },
          { "name": "高学历", "on": 0 },
          { "name": "工作能力强", "on": 0 },
          { "name": "高个子", "on": 0 }
        ],
        arr_girl: [
          { "name": "御姐", "on": 0 },
          { "name": "萝莉", "on": 0 },
          { "name": "大长腿", "on": 0 },
          { "name": "各种控", "on": 0 },
          { "name": "不污", "on": 0 },
          { "name": "二次元", "on": 0 },
          { "name": "呆萌", "on": 0 },
          { "name": "小火车", "on": 0 },
          { "name": "正太", "on": 0 },
          { "name": "暖男", "on": 0 },
          { "name": "硬汉", "on": 0 },
          { "name": "大叔", "on": 0 },
          { "name": "腹黑", "on": 0 },
          { "name": "男神", "on": 0 },
          { "name": "游戏", "on": 0 },

          { "name": "萝莉", "on": 0 },
          { "name": "御姐", "on": 0 },
          { "name": "大长腿", "on": 0 },
          { "name": "二次元", "on": 0 },
          { "name": "大眼萌妹", "on": 0 },
          { "name": "幽默有趣", "on": 0 },
          { "name": "善良温柔", "on": 0 },
          { "name": "爱好旅行", "on": 0 },
          { "name": "看剧追综艺", "on": 0 },
          { "name": "心思细腻", "on": 0 },
          { "name": "美妆达人", "on": 0 },
          { "name": "KTV王者", "on": 0 },
          { "name": "爱拍照", "on": 0 },
          { "name": "失眠患者", "on": 0 },
          { "name": "肉感身材", "on": 0 },
          { "name": "天然呆", "on": 0 },
          { "name": "毒舌但温柔", "on": 0 },
          { "name": "爱玩游戏", "on": 0 },
          { "name": "懒癌晚期", "on": 0 },
          { "name": "追求自由", "on": 0 },
          { "name": "喜欢小动物", "on": 0 },
          { "name": "JK控", "on": 0 },
          { "name": "辣妹穿搭", "on": 0 },
          { "name": "氛围感美女", "on": 0 },
          { "name": "对我偏爱", "on": 0 },
          { "name": "钟爱仪式感", "on": 0 }
        ],
      theme_dark: false
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },

  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_reload_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var sex = this.$route.params.sex;
      if (sex == "男生") {
        this.arr = this.arr_boy;
      }
      if (sex == "女生") {
        this.arr = this.arr_girl;
      }
      var inst = this.$route.params.inst;
      this.inst = inst.split("|");
      for (var i in this.inst) {
        var item = this.inst[i];
        var idx = tool.hasKey(this.arr, item, "name");
        this.arr[idx].on = 1;
      }
    },
    chosetag(index) {
      var tag = this.inst.splice(index, 1)[0];
      var recommendedTag = this.arr.find(item => item.name === tag);
      if (recommendedTag) recommendedTag.on = 0;
    },
    choseItem(item) {
      var idx = tool.hasKey(this.arr, item, "name");
      var on = this.arr[idx].on;
      if (on == 1) {
        this.arr[idx].on = 0;
        var idx_2 = this.inst.indexOf(item);
        if (idx_2 >= 0) {
          this.inst.splice(idx_2, 1);
        }
      } else {
        //判断数量，最多可选三个标签
        if (this.inst.length >= 3) {
          this.$refs.myConfirm.show("最多只能选三个标签哦~", {
            type: "alert",
            confirmText: "确定",
            titleText: "温馨提示",
            data: "",
          });
          return false;
        }
        this.arr[idx].on = 1;
        this.inst.push(item);
      }
    },
    save() {
      if (this.inst.length <= 0) {
        //提示选择图片
        this.$refs.myConfirm.show("请至少选择一个标签", {
          type: "alert",
          confirmText: "确定",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }

      //保存数据
      var send_data = { inst_tag: this.inst.join("|") };
      this.save_serve(send_data);
    },

    save_serve(send_data) {
      //后台保存信息
      var self = this;
      var uid = this.$store.state.uid;
      //var send_data = {'nick' : nick};
      var data = {
        url: "/App/User_ModifyBaseInfo",
        data: {
          uid: uid,
          data: JSON.stringify(send_data),
        },
        success: function (data_serve) {
          if (data_serve.state == "1") {
            self.act_reload_userinfo({
              uid: uid,
              success: function (info) {
                self.back();
              },
            });
          }
        },
      };
      self.post(data);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #EFEFEF;
}

.nav-lable {
  width: 4rem;
  height: 2rem;
  border-radius: 1rem;
  font-size: 0.9rem;
  background: linear-gradient(90deg, #8a61ff, #fe9cc0);
}

.edit-tags {
  margin-top: 1rem;
  padding: 0 0.8rem;
  .selected {
    margin-top: 1rem;
    .item {
      padding: 0.1rem 1rem;
      span {
        font-size: 0.75rem;
      }
    }
    .selected-on {
          margin-right: 0.5rem;
          padding: 0.3rem 0;
          background-color: transparent;
          color: #333;
          position: relative;
          background: transparent;
          border: none;
          cursor: pointer;
          z-index: 1;
          span {
            font-size: 0.65rem;
          }
          .del {
            margin-left: 0.5rem;
          }
    }
    .selected-on::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 2rem;
            padding: 1px;
            background: linear-gradient(to bottom, #8A61FF, #94E7E0);
            z-index: -1;
            -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
            mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
    }
  }
}

.recommended-tags {
  padding: 1rem 0.8rem;
  margin-top: 1rem;
  background-color: #FDFDFD;
  min-height: 20rem;
  border-radius: 1rem;
  span {
    color: #333;
  }
  .unselected {
    .label {
      padding: 0.5rem 1.3rem;
      margin-top: 0.5rem;
      margin-right: 0.5rem;
      border-radius: 2rem;
      background-color: #fff;
      span {
        color: #ab3fff;
        font-size: 0.75rem;
      }
    }
    .unselected-on {
        background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
        span {
          color: #fff;
        }
    }
  }
}

.container-dark {
  background-color: #2f2e33;
  .edit-tags {
    span {
      color: #fdfdfd;
    }
  }
  .recommended-tags {
    background-color: #2c2b30;
    span {
      color: #888;
    }
  }
}
</style>